export default __webpack_public_path__ + "static/media/Js.f3b41818.png";